import { event_button_click } from '@/utils/gtm';
import { Button } from '@/components/ui/buttons';
import { useTranslations } from 'next-intl';
import { useRouter } from '@/i18n/navigation';

const CompleteProfileBox = ({ closeMenu, session }) => {
  const t = useTranslations('common');
  const { push } = useRouter();

  return (
    <>
      {!session && (
        <div className='bg-primary mx-3 my-[11px] rounded-[10px] px-[15px] py-[13px] text-white'>
          <p className='pb-2.5 text-sm leading-[30px] font-bold'>
            {t('Login to Your Account or Register a new one')}
          </p>
          <Button
            onClick={() => {
              event_button_click({
                button_name: 'Login / Register',
                button_destination: '/login',
                button_location: 'side_menu',
              });
              push('/login');
              closeMenu();
            }}
            className='text-primary! rounded-full! bg-white text-sm font-bold'
          >
            {t('Login / Register')}
          </Button>
        </div>
      )}
    </>
  );
};

export default CompleteProfileBox;
